export const ADD_TO_REGISTRY = 'ADD_TO_REGISTRY';
export const ADD_TO_REGISTRY_ERROR = 'ADD_TO_REGISTRY_ERROR';
export const ADDED_TO_REGISTRY = 'ADDED_TO_REGISTRY';
export const CHECK_PRODUCT_REGISTRIES = 'CHECK_PRODUCT_REGISTRIES';
export const GET_REGISTRIES = 'GET_REGISTRIES';
// export const HIDE_PRODUCT_REGISTRIES = 'HIDE_PRODUCT_REGISTRIES';
export const PROMPT_REGISTRY_CREATE = 'PROMPT_REGISTRY_CREATE';
export const SET_PURCHASED_QUANTITY = 'SET_PURCHASED_QUANTITY';
export const SET_REGISTRY_ITEM_REMAINING_QUANTITY = 'SET_REGISTRY_ITEM_REMAINING_QUANTITY';
export const SET_REGISTRIES = 'SET_REGISTRIES';
// export const SHOW_PRODUCT_REGISTRIES = 'SHOW_PRODUCT_REGISTRIES';

export const ADD_TO_REGISTRY_ERROR_SLUG = 'product_add-to-registry-error-message';
export const ADDED_TO_REGISTRY_SUCCESS_SLUG = 'product_added-to-registry-success-message';

export default {
    ADD_TO_REGISTRY,
    ADD_TO_REGISTRY_ERROR,
    ADD_TO_REGISTRY_ERROR_SLUG,
    ADDED_TO_REGISTRY,
    ADDED_TO_REGISTRY_SUCCESS_SLUG,
    CHECK_PRODUCT_REGISTRIES,
    GET_REGISTRIES,
    // HIDE_PRODUCT_REGISTRIES,
    PROMPT_REGISTRY_CREATE,
    SET_REGISTRY_ITEM_REMAINING_QUANTITY,
    SET_PURCHASED_QUANTITY,
    SET_REGISTRIES,
    // SHOW_PRODUCT_REGISTRIES
};
